export enum ENotificationType {
  OrderCreated = 'order_created',
  DeliveryCreated = 'delivery_created',
  SolpedCreated = 'solped_created',
  SupplyOrderCreated = 'supply_order_created',
  EntryPlanCreated = 'entry_plan_created',
}

export default ENotificationType;
